module.exports = __webpack_public_path__ + "img/vue.6659c6c7.svg";